const SVG = ({ fill = "none", stroke="#7F7F7F", width = "20", height = "21", viewBox = "0 0 20 21" }) => (
  <svg width={width} height={height} viewBox={viewBox} fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.65765 11.45C10.211 11.45 11.4702 10.174 11.4702 8.6C11.4702 7.02599 10.211 5.75 8.65765 5.75C7.10435 5.75 5.84515 7.02599 5.84515 8.6C5.84515 10.174 7.10435 11.45 8.65765 11.45Z"
      stroke={stroke}
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.65765 20C12.4077 16.2 16.1577 12.7974 16.1577 8.6C16.1577 4.40264 12.7998 1 8.65765 1C4.51552 1 1.15765 4.40264 1.15765 8.6C1.15765 12.7974 4.90765 16.2 8.65765 20Z"
      stroke={stroke}
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default SVG;
